import * as React from "react";
import { RichTextArea } from "@grandvisionhq/common";
import { GlobalContactForm as GlobalContactForm$1 } from "@grandvisionhq/content";
import { useFeatureToggles } from "@grandvisionhq/state";
import { compose } from "@grandvisionhq/utils";
import CmsHeadTags from "../../../HeadTags/containers/HeadTags/HeadTags.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { useBrPageContext } from "../../../../context/context/context.js";
import { getBrPageContent } from "../../../../utils/utils/get-br-page-content.js";
import { useBloomreachRichText } from "../../../../hooks/hooks/use-bloomreach-rich-text.js";
const CmsGlobalContactForm = ({ component, meta }) => {
  const page = useBrPageContext();
  const { documentHeader: headerRef, documentFooter: footerRef } = component.getModels();
  const headerContent = getBrPageContent(page, headerRef[0]);
  const headerRichText = useBloomreachRichText(headerContent?.content?.value);
  const footerContent = getBrPageContent(page, footerRef[0]);
  const footerRichText = useBloomreachRichText(footerContent?.content?.value);
  const { country, brand, locale } = meta;
  const { featureConfigs } = useFeatureToggles();
  const { globalContactFormUrl } = featureConfigs;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CmsHeadTags, null, /* @__PURE__ */ React.createElement("link", { rel: "stylesheet", href: `${globalContactFormUrl}/styles.css` })), /* @__PURE__ */ React.createElement(
    GlobalContactForm$1,
    {
      country,
      brand,
      locale,
      headerRichText: /* @__PURE__ */ React.createElement(RichTextArea, { content: headerRichText }),
      footerRichText: /* @__PURE__ */ React.createElement(RichTextArea, { content: footerRichText })
    }
  ));
};
const GlobalContactForm = compose(
  withHidableContent,
  withBloomreachData,
  withEditableContent
)(CmsGlobalContactForm);
export {
  GlobalContactForm as default
};
//# sourceMappingURL=GlobalContactForm.js.map
